'use strict'

const CollectionInfiniteScroll = {
  instance: null,

  init() {
    if (typeof Ajaxinate === 'undefined') return

    const container = document.querySelector('.AjaxinateLoop')
    const pagination = document.querySelector('.AjaxinatePagination')

    if (!container || !pagination) {
      this.destroy()
      return
    }

    this.destroy()

    this.instance = new Ajaxinate({
      container: '.AjaxinateLoop',
      pagination: '.AjaxinatePagination',
      method: 'scroll',
      offset: 300,
      loadingText: '',
      callback: () => {
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger()
        }
      },
    })
  },

  destroy() {
    if (this.instance) {
      this.instance.destroy()
      this.instance.containerElement = null
      this.instance.paginationElement = null
      this.instance = null
    }
  },
}

document.addEventListener('DOMContentLoaded', () => {
  CollectionInfiniteScroll.init()
})
